import React from "react";

export default function Loader() {
    return (
        <div className="crm-loader-wrap">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <span className="crm-loader-text">Loading...</span>
        </div>
    );
}
